import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'shared-external-ecmrs-page',
    templateUrl: './shared.external.ecmrs.page.html',
    styleUrls: ['./shared.external.ecmrs.page.scss']
})
export class SharedExternalECMRsPage implements OnInit {

    constructor() {

    }

    ngOnInit(): void {
    }

    public pretty(value: any): string {
        return JSON.stringify(value);
    }

}
